import { getCurrentLocation, locationHandler } from '../services/Geolocation';

export const searchPreProcessor = (searchFunction, failureCallback) => {
  locationHandler({
    blockedPermissionsMessage: 'see the search results',
    permissionGrantedCallback: getCurrentLocation((position) => {
      const { coords } = position;
      searchFunction({
        options: {
          headers: {
            'X-Location': `${((coords || {}).latitude || 0.0).toFixed(6)},${(
              (coords || {}).longitude || 0.0
            ).toFixed(6)}`,
            'X-Accuracy': coords.accuracy,
          },
        },
      });
    }),
    permissionDeniedCallback: failureCallback,
  });
};

export const locationPreProcessor = (locationFunction, failureCallback) => {
  locationHandler({
    blockedPermissionsMessage: 'pick current location',
    permissionGrantedCallback: getCurrentLocation((position) => {
      const { coords } = position;
      locationFunction({
        lat: (coords || {}).latitude || 0.0,
        lng: (coords || {}).longitude || 0.0,
      });
    }),
    permissionDeniedCallback: failureCallback,
  });
};
